import {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {Accessibility, Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import {Noimage} from "@yb/ui/desktop/common/Noimage";

const SkipNavi = styled.div`
	a {
		position: absolute;
		display: block;
		width: 1px;
		height: 1px;
		margin-bottom: -1px;
		left: 0;
		top: 0;
		z-index: 100;
		font-size: 14px;
		font-weight: bold;
		color: #fff;
		text-align: center;
		overflow: hidden;
	}

	&:focus {
		width: 100%;
		height: auto;
		padding: 5px 0;
		background: #333;
	}
`;

const HeaderWrap = styled.header`
	letter-spacing: -0.02em;

	button {
		cursor: pointer;
		overflow: visible;
		border: 0 none;
		background-color: transparent;
		font-family: "PT-medium", Sans-serif;
		font-weight: normal;
		font-size: 15px;
		color: #555;
		text-indent: 0;
	}
	h1 a {
		display: block;
	}
	h1 a img {
		width: 165px;
		height: 44px;
		vertical-align: top;
	}
	nav {
		position: static;
	}
`;

const TopBanner = styled.div`
	position: relative;
	width: 100%;
	height: 70px;
	z-index: 11;

	a {
		display: block;
		height: 100%;
	}

	div {
		position: relative;
		width: 1200px;
		height: 70px;
		margin: 0 auto;
	}

	img {
		width: 100%;
		height: 100%;
		vertical-align: top;
	}
`;

const BtnBannerClose = styled.button`
	position: absolute;
	right: 0;
	top: 50%;
	width: 25px;
	height: 25px;
	padding: 0;
	margin: 0;
	border: 0;
	background: none;
	transform: translateY(-50%);

	&:before,
	&:after {
		position: absolute;
		right: -3px;
		height: 1px;
		width: 32px;
		background: #000;
		border-radius: 1px;
		content: "";
	}

	&:before {
		transform: rotate(45deg);
	}

	&:after {
		transform: rotate(-45deg);
	}
`;

const Container = styled.div`
	position: relative;
	padding-top: 30px;
	background-color: #fff;
	z-index: 10;
`;

const Gnb = styled.div`
	background-color: #fff;
	box-sizing: border-box;

	&::after {
		position: absolute;
		bottom: 0;
		height: 1px;
		width: 100%;
		background-color: #222;
		content: "";
	}
`;

const GnbWrap = styled.div`
	width: 1200px;
	margin: 0 auto;
`;

const TopNavWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 0 10px;

	> div:first-child {
		display: flex;
		gap: 30px;
		align-items: center;
	}

	h1 {
		line-height: 1;
	}
`;

const UtileLinks = styled.div`
	display: flex;
	gap: 40px;
	align-items: center;

	ul {
		display: flex;
	}
	li {
		position: relative;
		padding-right: 13px;
		margin-right: 10px;

		&:after {
			position: absolute;
			right: 0;
			top: 50%;
			display: inline-block;
			width: 3px;
			height: 3px;
			background-color: #ccc;
			transform: translateY(-50%);
			content: "";
		}

		&:last-child {
			padding-right: 0;
			margin-right: 0;
		}

		&:last-child::after {
			display: none;
		}
	}
	a {
		color: #111;
		font-size: 17px;
	}
`;

const BtnGroup = styled.div`
	display: flex;
	gap: 10px;

	a {
		box-sizing: border-box;
	}
`;

const BtnMypage = styled.a`
	width: 36px;
	height: 36px;
	background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_mypage.png) center / cover no-repeat;
`;

const Navi = styled.nav`
	margin-left: -15px;

	> ul {
		position: relative;
		z-index: 1;
		display: flex;
	}
`;

const BtnRecent = styled.a<{$hasRecent: boolean}>`
	${props =>
		props.$hasRecent
			? `width: 34px;
				height: 34px;
				border: 1px solid #bbb;
				border-radius: 8px;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
				}
				`
			: `
				width: 36px;
				height: 36px;
				border: none;
				background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_recent.png) center / cover no-repeat;
			`}
`;

const GnbItem = styled.a<{$isActive?: boolean}>`
	position: relative;
	display: block;
	padding: 20px 15px;
	font-family: "PT-regular";
	font-size: 17px;
	color: #555;
	line-height: 1;

	${props =>
		props.$isActive &&
		`
			color: #222;
			font-weight:bold;
	`}

	&:hover {
		color: #222;
		font-weight: bold;
	}
`;

const IconBadge = styled.span`
	position: absolute;
	top: -2px;
	left: 50%;
	height: 16px;
	width: 40px;
	border-radius: 13px;
	background-color: #ff5c46;
	color: #fff;
	font-size: 11px;
	text-align: center;
	font-family: "PT-bold";
	line-height: 1.6;
	transform: translateX(-50%);

	&:after {
		position: absolute;
		bottom: -3px;
		left: 50%;
		transform: translateX(-50%);
		width: 0px;
		height: 0px;
		border-top: 4px solid #ff5c46;
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		content: "";
	}
`;

const Lnb = styled.div`
	position: absolute;
	top: 163px;
	left: 0;
	width: 100%;
	height: 50px;
	background-color: #fff;
	border-bottom: 1px solid #ddd;
	box-sizing: border-box;
`;

const LnbWrap = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 1200px;
	margin: 0 auto;

	> ul {
		display: flex;
	}
`;

const Dim = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	display: none;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	z-index: -1;
`;

const Category = styled.div`
	position: absolute;
	left: 0;
	top: 50px;
	opacity: 0;
	width: 100%;
	min-height: 450px;
	height: 450px;
	background-color: #fff;
	transform: scaleX(0) scaleY(0);
	z-index: 10;
`;

const LnbItem = styled.li<{$isActive?: boolean}>`
	padding-left: 20px;

	&:first-child {
		padding-left: 0;
	}

	> a {
		position: relative;
		display: flex;
		align-items: center;
		height: 50px;
		font-size: 15px;
		color: #555;
		cursor: pointer;

		&:hover {
			font-weight: bold;
			color: #222;

			&:after {
				position: absolute;
				bottom: 1px;
				left: 50%;
				transform: translateX(-50%);
				display: block;
				width: 100%;
				height: 2px;
				background-color: #222;
				height: 2px;
				content: "";
			}
		}

		~ ${Category}:focus-within {
			opacity: 1;
			transform: scaleX(1) scaleY(1);
		}
	}

	&:hover ${Category} {
		opacity: 1;
		transform: scaleX(1) scaleY(1);
	}

	&:hover ${Dim} {
		display: block;
	}

	${Dim}:hover {
		display: none;
	}

	${props =>
		props.$isActive &&
		`
	> a {
		font-weight: bold;
		color: #222;

		&:after {
			position: absolute;
			bottom: 1px;
			left: 50%;
			transform: translateX(-50%);
			display: block;
			width: 100%;
			height: 2px;
			background-color: #222;
			height: 2px;
			content: "";
			}
		}

	`}
`;

const EventNavi = styled.ul`
	display: flex;
	gap: 15px;
	font-size: 14px;
	color: #777;

	li:hover {
		color: #4567ad;
	}
`;

const CategoryWrap = styled.div`
	display: flex;
	width: 1200px;
	height: 100%;
	margin: 0 auto;
`;

const CategorySubtitle = styled.span`
	display: block;
	font-family: "PT-medium";
	font-size: 18px;
	color: #4567ad;

	a {
		margin-left: 7px;
		color: #111;
	}
`;

const CategoryArea = styled.div`
	position: relative;
	padding: 30px;
	flex-basis: 300px;
	box-sizing: border-box;

	&:first-child {
		flex-grow: 1;
		background-color: #f5f5f5;
	}

	&:first-child:after {
		display: none;
	}

	&:after {
		position: absolute;
		right: 0;
		top: 0;
		width: 1px;
		height: 100%;
		background-color: #ddd;
		content: "";
	}

	ul {
		display: flex;
		flex-direction: column;
		gap: 20px;
		flex-wrap: wrap;
		height: 340px;
		width: 100%;
		margin-top: 20px;
	}

	li {
		width: 240px;
		line-height: 1;
	}
`;

const List = styled.ul`
	li a {
		display: block;
		width: 100%;
		align-items: center;
		font-size: 15px;
		color: #555;
		text-overflow: ellipsis;
		white-space: nowrap;
		-o-text-overflow: ellipsis;
		overflow: hidden;

		&:hover {
			color: #111;
			text-decoration: underline;
		}
	}
`;

const SearchWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 340px;
	height: 46px;
	padding: 0 25px 0 20px;
	border-radius: 30px;
	border: 2px solid #ffcb31;
	box-sizing: border-box;

	a {
		display: block;
		width: 100%;
		padding: 12px 0;
		color: #999;
		font-size: 15px;
		${Ellipsis(1)}
	}
`;

const BtnSearch = styled.button`
	position: relative;
	width: 23px;
	height: 22px;
	flex-shrink: 0;
	background: url(https://cimgcdn.ybtour.co.kr/common/button/btn_search.png) no-repeat;
	z-index: 1;
`;

const GnbUtil = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 30px;
	background-color: #f3f3f3;
	box-sizing: border-box;
	font-size: 13px;
	color: #555;

	ul {
		display: flex;
		gap: 20px;
		align-items: center;
		justify-content: end;
	}

	li:hover {
		color: #222;
	}

	a {
		line-height: 30px;
	}
`;

const GnbUtilWrap = styled.div`
	position: relative;
	width: 1200px;
	height: 100%;
	margin: 0 auto;
`;

const Login = styled.li<{$isShow: boolean}>`
	position: relative;
	padding-right: 12px;
	color: #111;
	cursor: pointer;

	&:after {
		content: "";
		position: absolute;
		top: 50%;
		right: 0;
		border-top: 4px solid #222;
		border-left: 3px solid transparent;
		border-right: 3px solid transparent;
		transform: translateY(-50%);
	}

	${props =>
		props.$isShow &&
		`
		&:after {
			border-top: 0;
			border-bottom: 4px solid #222;
		}
	`}
`;

const LoginTooltip = styled.div`
	position: absolute;
	top: 25px;
	right: -20px;
	z-index: 1;
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 110px;
	padding: 15px 15px 20px;
	border: 1px solid #222;
	border-radius: 3px;
	background-color: #fff;
	font-size: 13px;
	color: #555;
	box-sizing: border-box;

	&:before {
		content: "";
		position: absolute;
		top: -8px;
		right: 50%;
		width: 7px;
		height: 7px;
		background: #fff;
		border-right: 1px solid #222;
		border-bottom: 1px solid #222;
		transform: rotate(-135deg) translateX(-50%);
	}

	a {
		display: block;
		line-height: 1;

		&:hover {
			color: #4567ad;
			text-decoration: underline;
		}
	}
`;

const Header = () => {
	const [showTooltip, setShowTooltip] = useState(false);
	const tooltipRef = useRef<HTMLDivElement>(null);
	const [isHovered, setIsHovered] = useState(false);
	const loginRef = useRef<HTMLLIElement | null>(null);

	// 로그인시 나오는 툴팁
	const handleClickOutside = (event: MouseEvent) => {
		const target = event.target as Element | null;

		if (target && !tooltipRef.current?.contains(target) && !loginRef.current?.contains(target)) {
			setShowTooltip(false);
		}
	};

	useEffect(() => {
		if (showTooltip) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [showTooltip]);

	const handleClick = () => {
		setShowTooltip(prev => !prev);
	};

	// 1 Depth hover시 2 Depth 보여주기
	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);

	return (
		<HeaderWrap>
			<TopBanner style={{backgroundColor: "#fdebe9"}}>
				<div>
					<a href="#">
						<img src="https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner.jpg" alt="배너 이미지" />
					</a>
					<BtnBannerClose type="button">
						<span>배너 닫기</span>
					</BtnBannerClose>
				</div>
			</TopBanner>
			<Container>
				<SkipNavi>
					<a href="#content">본문 바로가기</a>
					<a href="#gnb">카테고리 메뉴 바로가기</a>
					<a href="#gnb-login">로그인 메뉴 바로가기</a>
				</SkipNavi>
				<Gnb>
					<GnbWrap id="gnb">
						<TopNavWrap>
							<div>
								<h1>
									<a href="/index.yb">
										<img src="https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png" alt="노랑풍선" />
									</a>
								</h1>
								<SearchWrap>
									<a href="#">검색 프로모션 영역 텍스트</a>
									<BtnSearch
										type="button"
										onClick={() => {
											location.href = `https://pkg.ybtour.co.kr/common/searchGoods.yb`;
										}}
									>
										<span>검색</span>
									</BtnSearch>
								</SearchWrap>
							</div>
							<UtileLinks>
								<ul>
									<li>
										<a href="#">베스트</a>
									</li>
									<li>
										<a href="#">마감임박</a>
									</li>
									<li>
										<a href="#">출발보장</a>
									</li>
									<li>
										<a href="#">썸머특가</a>
									</li>
									<li>
										<a href="#">당장노랑</a>
									</li>
								</ul>
								<BtnGroup>
									<BtnMypage href="https://pkg.ybtour.co.kr/mypage/index.yb">
										<Accessibility>마이페이지</Accessibility>
									</BtnMypage>
									{/* 최근 본 상품이 없을 경우 */}
									{/* <BtnRecent href="#" $hasRecent={false}>
										<Accessibility>최근본</Accessibility>
									</BtnRecent> */}
									{/* 최근 본 상품이 있을 경우 */}
									<BtnRecent href="#" $hasRecent={true}>
										<Accessibility>최근본</Accessibility>
										<Noimage
											width="32px"
											height="32px"
											src="https://dimgcdn.ybtour.co.kr/TN/99/99897c62991b42e78a3c3fad024dce69.tn.410x280.jpg"
											alt="상품 이미지"
										/>
									</BtnRecent>
								</BtnGroup>
							</UtileLinks>
						</TopNavWrap>
						<Navi>
							{/* 1 Depth */}
							<ul>
								<li>
									<GnbItem
										href="#"
										$isActive={isHovered}
										onMouseEnter={handleMouseEnter}
										onMouseLeave={handleMouseLeave}
									>
										해외패키지
									</GnbItem>
								</li>
								<li>
									<GnbItem href="#">에어텔</GnbItem>
								</li>
								<li>
									<GnbItem href="#">
										<IconBadge>NEW</IconBadge>
										허니문
									</GnbItem>
								</li>
								<li>
									<GnbItem href="#">
										<IconBadge>HOT</IconBadge>
										골프
									</GnbItem>
								</li>
								<li>
									<GnbItem href="#">크루즈</GnbItem>
								</li>
								<li>
									<GnbItem href="#">프리미엄</GnbItem>
								</li>
								<li>
									<GnbItem href="#">국내여행</GnbItem>
								</li>
								<li>
									<GnbItem href="#">항공</GnbItem>
								</li>
								<li>
									<GnbItem href="#">호텔</GnbItem>
								</li>
								<li>
									<GnbItem href="#">투어&amp;티켓</GnbItem>
								</li>
								<li>
									<GnbItem href="#">렌터카</GnbItem>
								</li>
								<li>
									<GnbItem href="#">기업/단체</GnbItem>
								</li>
							</ul>
							{/* 2 Depth */}
							{isHovered && (
								<Lnb onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
									<LnbWrap>
										<ul>
											<LnbItem $isActive={isHovered}>
												<a href="#">유럽</a>
												{/* 3 Depth */}
												<Category>
													<CategoryWrap>
														<CategoryArea>
															<CategorySubtitle>
																지역
																<a href="#">[해외패키지] 유럽</a>
															</CategorySubtitle>
															<List>
																<li>
																	<a href="#">[나라] 도시_1</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_2</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_3</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_4</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_5</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_6</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_7</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_8</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_9</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea>
															<CategorySubtitle>테마별</CategorySubtitle>
															<List>
																<li>
																	<a href="#">1</a>
																</li>
																<li>
																	<a href="#">2</a>
																</li>
																<li>
																	<a href="#">3</a>
																</li>
																<li>
																	<a href="#">4</a>
																</li>
																<li>
																	<a href="#">5</a>
																</li>
																<li>
																	<a href="#">6</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea>
															<CategorySubtitle>프로모션</CategorySubtitle>
															<List>
																<li>
																	<a href="#">
																		절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가 프로모션 프로모션 프로모션 프로모션
																	</a>
																</li>
																<li>
																	<a href="#">아시아나 항공 유럽 SUMMER 특가</a>
																</li>
																<li>
																	<a href="#">유럽의 숨겨진 보물, HENANN RESORT</a>
																</li>
																<li>
																	<a href="#">상상 이상의 행복한 허니문을 위한 Fourseasons in France</a>
																</li>
																<li>
																	<a href="#">절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가</a>
																</li>
															</List>
														</CategoryArea>
													</CategoryWrap>
												</Category>
												<Dim />
											</LnbItem>
											<LnbItem>
												<a href="#">동남아</a>
												<Category>
													<CategoryWrap>
														<CategoryArea>
															<CategorySubtitle>
																지역별
																<a href="#">[해외패키지] 동남아</a>
															</CategorySubtitle>
															<List>
																<li>
																	<a href="#">[나라] 도시_1</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_2</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_3</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_4</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_5</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_6</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_7</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_8</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_9</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_10</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_11</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_12</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_13</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_14</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_15</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_16</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_17</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_18</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea>
															<CategorySubtitle>테마별</CategorySubtitle>
															<List>
																<li>
																	<a href="#">1</a>
																</li>
																<li>
																	<a href="#">2</a>
																</li>
																<li>
																	<a href="#">3</a>
																</li>
																<li>
																	<a href="#">4</a>
																</li>
																<li>
																	<a href="#">5</a>
																</li>
																<li>
																	<a href="#">6</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea>
															<CategorySubtitle>프로모션</CategorySubtitle>
															<List>
																<li>
																	<a href="#">창립 21주년 기념, 동남아 5만원 할인!</a>
																</li>
																<li>
																	<a href="#">격리없이 떠나는 푸켓</a>
																</li>
																<li>
																	<a href="#">샹그릴라&요트선셋투어 in 싱가포르</a>
																</li>
																<li>
																	<a href="#">동남아! 할인챌린지 앙코르전</a>
																</li>
																<li>
																	<a href="#">아시아나 A380 타고 떠나는 방콕/파타야</a>
																</li>
															</List>
														</CategoryArea>
													</CategoryWrap>
												</Category>
												<Dim />
											</LnbItem>
											<LnbItem>
												<a href="#">일본</a>
												<Category>
													<CategoryWrap>
														<CategoryArea>
															<CategorySubtitle>
																지역별
																<a href="#">[해외패키지] 일본</a>
															</CategorySubtitle>
															<List>
																<li>
																	<a href="#">[나라] 도시_1</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_2</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_3</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea></CategoryArea>
														<CategoryArea>
															<CategorySubtitle>프로모션</CategorySubtitle>
															<List>
																<li>
																	<a href="#">오사카 여행 200% 즐기는 방법</a>
																</li>
																<li>
																	<a href="#">나만 알고싶은 소도시로, 단풍여행</a>
																</li>
																<li>
																	<a href="#">겨울시즌 온천여행 오이타</a>
																</li>
																<li>
																	<a href="#">황금연휴 출발확정</a>
																</li>
																<li>
																	<a href="#">MZ 취향저격 특급호텔 호캉스 MZ 취향저격 특급호텔 호캉스</a>
																</li>
															</List>
														</CategoryArea>
													</CategoryWrap>
												</Category>
												<Dim />
											</LnbItem>
											<LnbItem>
												<a href="#">괌/사이판</a>
												<Category>
													<CategoryWrap>
														<CategoryArea>
															<CategorySubtitle>
																지역별
																<a href="#">[해외패키지] 괌/사이판</a>
															</CategorySubtitle>
															<List>
																<li>
																	<a href="#">[나라] 도시_1</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_2</a>
																</li>
																<li>
																	<a href="#">[나라] 도시_3</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea>
															<CategorySubtitle>테마별</CategorySubtitle>
															<List>
																<li>
																	<a href="#">여행에 테마를 더하다</a>
																</li>
															</List>
														</CategoryArea>
														<CategoryArea></CategoryArea>
													</CategoryWrap>
												</Category>
												<Dim />
											</LnbItem>
											<LnbItem>
												<a href="#">호주/뉴질랜드</a>
											</LnbItem>
											<LnbItem>
												<a href="#">미주/캐나다/하와이</a>
											</LnbItem>
											<LnbItem>
												<a href="#">중남미/아프리카</a>
											</LnbItem>
											<LnbItem>
												<a href="#">대만/홍콩/마카오</a>
											</LnbItem>
											<LnbItem>
												<a href="#">중국/몽골/중아아시아</a>
											</LnbItem>
											<LnbItem>
												<a href="#">부산/지방 출발</a>
											</LnbItem>
										</ul>
										<EventNavi>
											<li>
												<a href="#">기획전</a>
											</li>
											<li>
												<a href="#">이벤트</a>
											</li>
											<li>
												<a href="#">홈쇼핑</a>
											</li>
										</EventNavi>
									</LnbWrap>
								</Lnb>
							)}
						</Navi>
					</GnbWrap>
					<GnbUtil id="gnb-login">
						<GnbUtilWrap>
							<ul>
								{/* 로그아웃 상태  */}
								{/* <li>
									<a href="#">로그인</a>
								</li>
								<li>
									<a href="#">회원가입</a>
								</li> */}
								{/* 로그인 상태 */}
								<Login onClick={handleClick} $isShow={showTooltip} ref={loginRef}>
									김노랑 님
									{showTooltip && (
										<LoginTooltip ref={tooltipRef}>
											<a href="#">개인정보 수정</a>
											<a href="#">비밀번호 변경</a>
											<a href="#">SNS 연결 설정</a>
										</LoginTooltip>
									)}
								</Login>
								<li>
									<a href="#">로그아웃</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/mypage/resvInfo.yb">예약확인/결제</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/main.yb">고객센터</a>
								</li>
							</ul>
						</GnbUtilWrap>
					</GnbUtil>
				</Gnb>
			</Container>
		</HeaderWrap>
	);
};

export {
	SkipNavi,
	HeaderWrap,
	TopBanner,
	BtnBannerClose,
	Container,
	Gnb,
	GnbWrap,
	TopNavWrap,
	UtileLinks,
	BtnGroup,
	BtnMypage,
	Navi,
	BtnRecent,
	GnbItem,
	IconBadge,
	Lnb,
	LnbWrap,
	Dim,
	Category,
	LnbItem,
	EventNavi,
	CategoryWrap,
	CategorySubtitle,
	CategoryArea,
	List,
	SearchWrap,
	BtnSearch,
	GnbUtil,
	GnbUtilWrap,
	Login,
	LoginTooltip,
};
export default Header;
